module.exports = __webpack_public_path__ + "stylesheets/footer_f7f87141e57485f1776d23f14999e992.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/footer.less
// module id = fAML
// module chunks = 55